/* unplugin-vue-components disabled */import { render } from "./newsid.vue?vue&type=template&id=5f9cabc6&scoped=true"
import script from "./newsid.vue?vue&type=script&lang=js"
export * from "./newsid.vue?vue&type=script&lang=js"

import "./newsid.vue?vue&type=style&index=0&id=5f9cabc6&scoped=true&lang=css"

import exportComponent from "D:\\PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP\\官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9cabc6"]])

export default __exports__